import { Box } from "@garther/ui/components";

import { TranslateFn } from "../../libs/utils/type";

interface QuizHeaderProps {
  currentQuestion: number;
  totalQuestions: number;
  title?: string;
  description?: string;
  t: TranslateFn;
}

export default function QuizHeader({
  currentQuestion,
  totalQuestions,
  title,
  description,
  t
}: QuizHeaderProps) {
  // Use provided title/description or fallback to translations
  const displayTitle = title || t("quiz.header.title");
  const displayDescription = description || t("quiz.header.description");

  const progress = ((currentQuestion + 1) / totalQuestions) * 100;

  return (
    <Box>
      <div>
        {/* Title and Progress */}
        <div className="flex justify-between items-start mb-4 sm:mb-6">
          <div className="flex-1">
            <h1 className="text-text-primary text-responsive-2xl mb-2">{displayTitle}</h1>
            <p className="text-text-secondary text-responsive-base max-w-2xl">{displayDescription}</p>
          </div>
          <div className="text-right ml-4 sm:ml-6">
            <div className="text-text-primary text-responsive-2xl font-normal">{currentQuestion + 1}</div>
            <div className="text-text-secondary text-responsive-base">
              {t("quiz.header.of")} {totalQuestions}
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-background-highlight rounded-full h-2 sm:h-3 mb-4 sm:mb-6 overflow-hidden">
          <div
            className="bg-background-dark h-2 sm:h-3 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Progress Text */}
        <div className="text-center">
          <span className="text-text-secondary text-responsive-sm">
            {t("quiz.header.questionOf", {
              current: currentQuestion + 1,
              total: totalQuestions
            })}
          </span>
        </div>
      </div>
    </Box>
  );
}
